export const PREVIEW_PAGE_ENUM = {
  SHOWROOM_PAGE_PREVIEW: 'page',
  SHOWROOM_PRODUCT_PREVIEW: 'product',
  BLOG_PREVIEW: 'blog',
}
